var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialTwIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.33333C11.676 1.33333 14.6667 4.324 14.6667 8C14.6667 11.676 11.676 14.6667 8 14.6667C4.324 14.6667 1.33333 11.676 1.33333 8C1.33333 4.324 4.324 1.33333 8 1.33333ZM8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0ZM12.3333 5.85203C12.0393 5.9827 11.7227 6.0707 11.3907 6.1107C11.73 5.90736 11.9893 5.58603 12.1127 5.2027C11.7953 5.3907 11.444 5.52736 11.07 5.6007C10.7713 5.28136 10.344 5.08203 9.87267 5.08203C8.81267 5.08203 8.034 6.0707 8.27333 7.09736C6.91 7.0287 5.7 6.37536 4.89067 5.3827C4.46067 6.12003 4.668 7.08536 5.39867 7.57403C5.13 7.56536 4.87733 7.49136 4.656 7.3687C4.638 8.1287 5.18333 8.84003 5.97267 8.9987C5.742 9.06137 5.48867 9.07603 5.23133 9.0267C5.44 9.6787 6.04733 10.1527 6.76467 10.166C6.07333 10.7074 5.20467 10.9494 4.33333 10.8467C5.06 11.3127 5.922 11.584 6.84867 11.584C9.89667 11.584 11.618 9.01003 11.514 6.70136C11.8353 6.4707 12.1133 6.18136 12.3333 5.85203Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwIcon);
export default __webpack_public_path__ + "static/media/social-tw-icon.d6c503c6abfdcbc7370fe617eb7d4c2f.svg";
export { ForwardRef as ReactComponent };